import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { getDateDiff, getPartWarranty } from "../../../../utils/HelperFunction";
import MyDataTable from "../../../../component/MyDataTable";

const DefectivePartPendingOnSF = ({reloadList, setReload}) => {


  const columns = [
    {
      name: "SNo.",
      selector: (row) => '', // Placeholder, as we don't need to select data from the row itself
      cell: (row, index) => index + 1, // Use cell to render the incrementing number
    },
    {
      name: <div className="word-wrap">Part Requested ID</div>,
      selector: (row) => row.id,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Booking ID</div>,
      selector: (row) => row.booking_detail.booking_id,
      cell: (row) => (
        <NavLink to={`/getbookingdetails?bid=${btoa(row.booking_detail.id)}`}>
          {row.booking_detail.booking_id}
        </NavLink>
      ),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Customer Name</div>,
      selector: (row) => row.booking_detail.user_detail.customer_name,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Appliance / Brand</div>,
      selector: (row) =>
        `${row.booking_detail.appliance.appliance_name} / ${row.booking_detail.user_appliance_detail.brand.brand_name}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Requested Part Name / Number</div>,
      selector: (row) =>
        `${row.requested_part.part_name} /  ${row.requested_part.part_number}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Shipped Part Name/ Number</div>,
      selector: (row) =>
        `${row.shipped_part.part_name} /  ${row.shipped_part.part_number}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Requested / Shipped Model Number</div>,
      selector: (row) =>
        `${row.requested_model.model_number} / ${row.shipped_model.model_number}`,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Serial Number</div>,
      selector: (row) =>
        row.booking_detail.user_appliance_detail.sf_serial_number,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Consumption</div>,
      selector: (row) =>
        row?.consumption_status?.status || "Part Not Consumed",
      wrap: true,
    },
    {
      name: <div className="word-wrap">Warranty Status</div>,
      selector: (row) => getPartWarranty(row.warranty_status),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Quantity</div>,
      selector: (row) => row.shipped_quantity,
      wrap: true,
    },
    {
      name: "Age",
      selector: (row) =>
        `${getDateDiff(row.booking_detail.sc_closed_date || row.forward_part_ack_date)} days`,
      wrap: true,
    },
  ];

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">
                    Defective Part Pending On SF
                  </h3>
                </div>
                <MyDataTable
                  reloadList={reloadList}
                  columns={columns}
                  getDataListURL={`getdefectivetobeshppementlist?isdefective=1`}
                  setReload={setReload}
                  exportName={"defectivepart"}
                />
              </div>
            </div>
          </div>
        </div>

      </section>
    </div>
  );
};

export default DefectivePartPendingOnSF;
